
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vfair",
      function () {
        return require("private-next-pages/vfair/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vfair"])
      });
    }
  